<template>

<div class="modal " v-bind:class="{ 'is-active' : showProcessModal} " >
            <div class="modal-background"></div>
            <div class="modal-card process" style="width:1020px">
                <header class="modal-card-head">
                <p class="modal-card-title">Process Request</p>
                <button class="delete" aria-label="close" @click="closeModal()"></button>
                </header>
                <section class="modal-card-body">
                  <form action="" @submit.prevent="processSample()">
              <table class="table is-fullwidth is-striped is-size-7">
                  <thead>
                      <tr>
                          <th>#</th>
                          <th>Garment</th>
                          <th>Type</th>
                          <th>Qty</th>
                          <th>Extras</th>
                          <th>Print</th>
                          <th>Gerber Cutting</th>
                          <th>Cut/Sew Cutting</th>
                          <th>Makeup</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="(row, index) in sample.items" :key="row.id">
                          <td>{{  index + 1 }}</td>
                          <td>{{ row.garmentname}}</td>
                          <td>{{ row.sample_item_type_name}}</td>
                          <td>{{  row.quantity }}</td>
                          <td class="">
                            <div class="tags">
                              <span class="tag " v-if="row.embroidery==1">Embroidery</span>
                              <span class="tag " v-if="row.trims==1">Trims</span>
                              <span class="tag " v-if="row.dtf==1">DTF</span>
                              <span class="tag " v-if="row.silicon==1">Silcon</span>
                            </div>
                          </td>
                          <td>
                            <select class="select" v-model="row.print_location_id" required @change="updateLocationRows(row)">
                              <option value="">Select</option>
                              <option v-for="row in printing_locations" :key="row.id" :value="row.id">{{ row.name }}</option>
                            </select>
                          </td>
                          <td>
                            <select class="select" v-model="row.cutting_location_id" required>
                              <option value="">Select</option>
                              <option v-for="row in cutting_locations" :key="row.id" :value="row.id">{{ row.name }}</option>
                            </select>
                          </td>
                          <td>
                            <select class="select" v-model="row.cutsew_cutting_location_id" required v-if="isItemCutSew(row)">
                              <option value="">Select</option>
                              <option v-for="row in cutting_locations" :key="row.id" :value="row.id">{{ row.name }}</option>
                            </select>
                          </td>
                          <td>
                            <select class="select" v-model="row.makeup_location_id" required>
                              <option value="">Select</option>
                              <option v-for="row in makeup_locations" :key="row.id" :value="row.id">{{ row.name }}</option>
                            </select>
                          </td>
                      </tr>
                     
                      
                  </tbody>
              </table>

              <button class="button is-success" type="submit" :disabled="working==true">Process</button> 

              </form>
            </section>
          </div>
        </div>

       


    </template>


<script>
    import SampleService from '@/services/SampleService.js';
    //import UtilityService from '@/services/UtilityService.js';

    

    export default {
      
      name: 'AddStone',
        mixins: [],
        data: function () {
            return {
                   loading : false,
                  search: "",
                    API_NAME: process.env.VUE_APP_API_NAME,
                    accessToken: '',
                    sample: [],
                    users: [],
                   
                    working:false,
                   makeup_locations: [],
                   printing_locations: [],
                   cutting_locations: []

                   
            }
        },
        props: ['showProcessModal', 'sample_id'],
        created() {
          this.getAccessToken()
            .then(() => { 
               //this.getSample();
               this.getSamplesMakeupLocations();
               this.getSamplesPrintingLocations();
               this.getSamplesCuttingLocations();
            });
          
        },
        methods: {
          isItemCutSew(row) {
            return  Number(row.sample_item_type_id) === 2 || Number(row.sample_item_type_id) === 3; // Part printed or cut/sew
          },
          async getSamplesMakeupLocations() {
            SampleService.getSamplesMakeupLocations(this.accessToken)
            .then(
              (makeup_locations => {
                this.$set(this, "makeup_locations", makeup_locations);
              }).bind(this)
            );
          },
          async getSamplesPrintingLocations() {
            SampleService.getSamplesPrintingLocations(this.accessToken)
            .then(
              (printing_locations => {
                this.$set(this, "printing_locations", printing_locations);
              }).bind(this)
            );
          },
          async getSamplesCuttingLocations() {
            SampleService.getSamplesCuttingLocations(this.accessToken)
            .then(
              (cutting_locations => {
                this.$set(this, "cutting_locations", cutting_locations);
              }).bind(this)
            );
          },
        updateLocationRows(row) {
            if(row.print_location_id > 0)
            {
              
                if(row.cutting_location_id == '' || row.cutting_location_id == null)
                {
                  row.cutting_location_id = row.print_location_id
                }

                if(row.cutsew_cutting_location_id == '' || row.cutsew_cutting_location_id == null)
                {
                  row.cutsew_cutting_location_id = row.print_location_id
                }

                if(row.makeup_location_id == '' || row.makeup_location_id == null)
                {
                  row.makeup_location_id = row.print_location_id
                }
            }
        },
          closeModal() {
            this.sample = []
            this.$emit("hide-modal");
          },
            
            async getSample() {
                this.loading=true
                SampleService.getSample(this.accessToken, this.sample_id)
                .then(
                    (sample => {
                        this.$set(this, "sample", sample);
                        this.loading=false
                        this.working = false
                        
                    }).bind(this)
                );
            },
            async processSample() {
                
                this.working = true
                var formdata = { 
                    items: this.sample.items
                }; 

                SampleService.processSample(this.accessToken, this.sample_id, formdata)
                .then((response) => {
                  this.sample = []
                  this.$emit("reload-samples");
                    console.log(response)
                    
                    }).catch((error) => {
                        if(error.response.status === 422)
                        {
                            console.log("Error:" + JSON.stringify(error.response.data));
                        }
                        alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                        this.working = false
                });
                
            },
           
           
        },
        watch: {
         
          showProcessModal() {
            this.getSample();
          }
        }
    }
    </script>
    